import { ProductVariant } from '@medusajs/medusa'

type LineItemOptionsProps = { variant: ProductVariant }

const LineItemOptions = ({ variant }: LineItemOptionsProps) => {
  // `options` is not eager-loaded on a cart line item's variant, so it can be
  // missing on an item the products query hasn't enriched yet.
  const options = variant?.options ?? []
  const productOptions = variant?.product?.options ?? []

  return (
    <div className="text-small-regular text-gray-700">
      {options.map((option) => {
        const optionName =
          productOptions.find((opt) => opt.id === option.option_id)?.title ||
          'Option'
        return (
          <div key={option.id}>
            <span>
              {optionName}: {option.value}
            </span>
          </div>
        )
      })}
    </div>
  )
}

export default LineItemOptions
